import { createContext } from 'react';

export const ConfigContext = createContext(null);
export const MonitorContext = createContext(null);
export const UserContext = createContext(null);
export const FavouritesContext = createContext(null);
